// @flow

import { useHref } from 'react-router-dom';

import { selectCartUUID } from '@gandi/cart';
import { selectCurrentId } from '@gandi/redux-sharing';

import { getSetupOverviewUrl } from 'src/Cart/Setup/modules/helpers';
import { useAppSelector } from 'src/hooks/useAppSelector';

import { useCartSummaryContext } from '../../../../context/CartSummary';

import { selectNavigationMode } from './selectNavigationMode';

export function useRoutingAfterAccountChoice(): () => Promise<void> {
  const currentPath = useHref('');
  const cartId = useAppSelector(selectCartUUID);
  const mode = useAppSelector(selectNavigationMode);

  const { updateSharingIdContext } = useCartSummaryContext();
  const sharingId = useAppSelector(selectCurrentId);

  return async () => {
    // Evaluate reload necessity using router context
    const reload = !currentPath.includes(sharingId);
    const targetRoute =
      mode === 'configure'
        ? getSetupOverviewUrl(cartId)
        : `/cart/${cartId}/overview`;

    await updateSharingIdContext({
      newSharingId: sharingId,
      guess: false,
      route: targetRoute,
      reload,
    });
  };
}
